export const notificationIcon = [
  '65 65',
  `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
  <g id="_9026869_house_simple_thin_icon_1_" data-name="9026869_house_simple_thin_icon (1)" transform="translate(0.374 -0.023) ">
    <rect id="Rectángulo_102" data-name="Rectángulo 102" width="25" height="25" transform="translate(-0.374 0.023)" fill="none"/>
    <path id="Trazado_408" data-name="Trazado 408" d="M56.8,42.049l-7.75-7.043a.775.775,0,0,0-1.046,0l-7.75,7.043A.8.8,0,0,0,40,42.62v8.961a.775.775,0,0,0,.775.775h15.5a.775.775,0,0,0,.775-.775V42.62a.8.8,0,0,0-.252-.572Z" transform="translate(-35.984 -31.232)" fill="none" stroke="#47b2e5" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6"/>
  </g>
</svg>`,
];